import { ProLayoutProps } from "@ant-design/pro-components";
const Settings: ProLayoutProps & { pwa?: boolean; logo?: string } = {
  colorPrimary: "#1890ff",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  layout: "side",
  logo: "/logo.png",
  navTheme: "light",
  pwa: true,
  siderMenuType: "sub",
  splitMenus: false,
  title: process.env.UMI_APP_TITLE || "",
  token: {},
};
export default Settings;
